export default [
  {
    children: [
      {
        component: () => import("@/components/estoque/historico/historico-produtos-print.vue"),
        name: "estoque.historico.print",
        path: "/estoque/historico/print",
        label: "Imprimir Histórico de Movimentação de Produtos",
      },
      {
        component: () => import("@/components/pcp/producao/print-formulacao-ordem-producao.vue"),
        name: "pcp.producao.formulacao.ordem.producao.print",
        path: "/print/formulacao/ordem-producao/:id/:tipo_item/:ordem_producao/:quantidade",
        label: "Imprimir Formulação de Ordem de Produção",
      },
      {
        component: () => import("@/components/pcp/producao/print-formulacao-ordem-producao-todos.vue"),
        name: "pcp.producao.formulacao.ordem.producao.print.todos",
        path: "/print/formulacao/ordem-producao/:ordem_producao/todos",
        label: "Imprimir Formulações de Todos os Itens da Ordem de Produção",
      },
      {
        component: () => import("@/components/pcp/producao/print-formulacao-ordem-producao-todos.vue"),
        name: "pcp.producao.formulacao.grupo.print.todos",
        path: "/print/formulacao/grupo-op/:grupo_op/todos",
        label: "Imprimir Formulações do Grupo de OPs",
      },
      {
        component: () => import("@/components/pcp/producao/print-resumo-produto-acabado.vue"),
        name: "pcp.producao.resumo.produto-acabado.print",
        path: "/print/resumo/ordem-producao/:ordem_producao/produto-acabado",
        label: "Imprimir Resumo de Produto Acabado",
      },
      {
        component: () => import("@/components/pcp/producao/print-resumo-produto-acabado.vue"),
        name: "pcp.producao.resumo.produto-acabado.grupo.print",
        path: "/print/resumo/grupo-op/:grupo_op/produto-acabado",
        label: "Imprimir Resumo de Produto Acabado do Grupo",
      },
      {
        component: () => import("@/components/pcp/relatorios/linhas-producao-print.vue"),
        name: "pcp.relatorios.linhas-producao.print",
        path: "/print/pcp/relatorios/linhas-producao",
        label: "Imprimir Relatório de Linhas de Produção",
      },
      {
        component: () => import("@/components/pcp/producao/print-corte-grupo.vue"),
        name: "pcp.producao.corte.grupo.print",
        path: "/print/corte/grupo-op/:grupo_op",
        label: "Imprimir Resumo de Corte do Grupo de OPs",
      },
      {
        component: () => import("@/components/pcp/producao/print-ficha-envio-faccao.vue"),
        name: "pcp.producao.ficha-envio.print",
        path: "/print/ordem-producao/:ordem_producao/ficha-envio",
        label: "Imprimir Ficha de Envio de Lote",
        meta: { permission: "pcp.producao.formulacao.ordem.producao.print" },
      },
      {
        component: () => import("@/components/pcp/producao/print-ficha-envio-faccao.vue"),
        name: "pcp.producao.grupo-op.ficha-envio.print",
        path: "/print/grupo-op/:grupo_op/ficha-envio",
        label: "Imprimir Ficha de Envio de Lote do Grupo",
        meta: { permission: "pcp.producao.formulacao.ordem.producao.print" },
      },
      {
        component: () => import("@/components/controladoria/cenarios/cenario-print.vue"),
        name: "controladoria.cenarios.imprimir",
        label: "Imprimir Cenários de Custo",
        path: "/controladoria/cenario-print/:id",
      },
      {
        component: () => import("@/components/faturamento/nfe/PrintBinario.vue"),
        name: "faturamento.nfe.gerenciar.print-binario",
        label: "Imprimir",
        path: "/faturamento/nfe/:id",
      },
      {
        component: () => import("@/components/estoque/relatorios/produtos-custo-print.vue"),
        name: "estoque.relatorios.custo.print",
        label: "Imprimir Relatório de Custos Totais",
        path: "/estoque/relatorios/custos-totais-print",
      },
      {
        component: () => import("@/components/estoque/cadastros/produto/etiquetas-comercio/produtos-etiqueta.vue"),
        name: "estoque.cadastros.produtos.etiquetas-print",
        path: "/estoque/produtos/etiquetas",
        label: "Imprimir Etiquetas de Produtos (A4)",
      },
      {
        component: () =>
          import("@/components/estoque/cadastros/produto/etiquetas-comercio/produtos-etoquetas-3-colunas.vue"),
        name: "estoque.cadastros.produtos.etiquetas-3-colunas-print",
        path: "/estoque/produtos/etiquetas-3-colunas",
        label: "Imprimir Etiquetas de Produtos (3 Colunas)",
      },
      {
        component: () => import("@/components/logistica/romaneio/gerenciar-romaneio-show.vue"),
        name: "logistica.romaneio.romaneio-print",
        label: "Imprimir Romaneios",
        path: "/logistica/romaneio/romaneio-print/:id",
      },
      {
        component: () => import("@/components/logistica/romaneio/gerenciar-romaneio-show-resumo.vue"),
        name: "logistica.romaneio.romaneio-print-resumo",
        label: "Imprimir Resumo de Romaneios",
        path: "/logistica/romaneio/resumo-romaneio-print/:id",
      },
      {
        component: () => import("@/components/faturamento/os/print-os.vue"),
        path: "/faturamento/os/print/:id",
        name: "faturamento.ordem-servico.imprimir",
        label: "Imprimir Ordem de Serviço",
      },
      {
        component: () => import("@/components/faturamento/nfe/print-nfe.vue"),
        path: "/faturamento/nfe/print/:id",
        name: "faturamento.nfe.gerenciar.print",
        label: "Imprimir Detalhes da Nota Fiscal",
      },
      {
        component: () => import("@/components/dashboards/vendas/vendas-tempo-real.vue"),
        name: "dashboard.vendas.tempo-real-venda",
        label: "Visualizar Vendas em Tempo Real",
        path: "/dashboard/vendas/tempo-real",
      },
      {
        component: () => import("@/components/dashboards/vendas/vendas-tempo-real-cidades.vue"),
        name: "dashboard.vendas.tempo-real-vendas-cidades",
        path: "/dashboard/vendas/tempo-real-cidades",
        label: "Visualizar Vendas em Tempo Real por Cidades",
      },
      {
        component: () => import("@/components/dashboards/vendas/vendas-tempo-real-grupo-produtos.vue"),
        name: "dashboard.vendas.tempo-real-vendas-grupo-produtos",
        label: "Visualizar Vendas em Tempo Real por Grupo de Produtos",
        path: "/dashboard/vendas/tempo-real-grupo-produtos",
      },
      {
        component: () => import("@/components/crm/metas/MetasTempoReal.vue"),
        name: "crm.metas.tempo-real",
        label: "Dashboard de Metas em Tempo Real",
        path: "/crm/metas/tempo-real",
      },
      {
        path: "/estoque/depositos/movimentacao/imprimir",
        name: "estoque.cadastros.depositos.imprimir-movimentacoes",
        label: "Imprimir Movimentações de Depósitos",
        component: () => import("@/components/estoque/cadastros/depositos/movimentacao-print.vue"),
      },
      {
        path: "/estoque/depositos/visualizar/imprimir",
        name: "estoque.cadastros.depositos.imprimir-produtos",
        label: "Imprimir Produtos de um Depósito",
        component: () => import("@/components/estoque/cadastros/depositos/deposito-produtos-print.vue"),
      },
    ],
    component: () => import("@/layout/LayoutBlank.vue"),
    meta: { requiresAuth: true, requiresEmitente: true },
    path: "/",
  },
];
